<template>
    <div>
        <div class="companyManagement-title">{{ $t('companyManagement.title') }}</div>

        <div class="companyManagement-top">
            <company-management-search></company-management-search>
        </div>
        <table-company-management></table-company-management>
    </div>
</template>

<script>
    import CompanyManagementSearch from '../company_management/CompanyManagementSearch'
    import TableCompanyManagement from '../company_management/TableCompanyManagement'
    export default {
        name: 'CompanyManagement',
        components: {
            CompanyManagementSearch,
            TableCompanyManagement
        }
    }
</script>

<style scoped>
    .companyManagement-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .companyManagement-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/company_management/CompanyManagement.vue